import React from 'react';
import BaseSimplePage from "../BaseSimplePage/BaseSimplePage";
import TagsItemForm from "./TagsItemForm";
import TagsItemBrowser from "./TagsItemBrowser";

const TagsPage = ({isAddSubMode}) => {

    return (
        <BaseSimplePage
            isAddSubMode={isAddSubMode}
            modeApiName1="tag"
            modeApiName2="tags"
            ItemFormComponent={TagsItemForm}
            ItemBrowserComponent={TagsItemBrowser}
        />
    );
};

export default TagsPage;